module.exports = __webpack_public_path__ + "d336c0a23b35cf6331877898e7e1c71f.png";